module.exports = __webpack_public_path__ + "img/06_1.7ddb4299.png";